import React from 'react';
import PlayerPresenceDirectory from '../components/presence/PlayerPresenceDirectory';
import GalaxyGateWidget from '../components/galaxy/GalaxyGateWidget';

function PresenceDirectory() {
  return (
    <div className="container py-3">
      <h2 className="mb-3">Player Presence Directory</h2>
      <PlayerPresenceDirectory />
      <div className="mt-4">
        <GalaxyGateWidget mode="auto" />
      </div>
    </div>
  );
}

export default PresenceDirectory;
